import React from "react";
import Spotip17anPlaylist from "../spotip17an-playlist/spotip17an-playlist";

const SpotipitanAllSongs = () => {
    return (
        <Spotip17anPlaylist isAllSongs={true} />
    );
};

export default SpotipitanAllSongs;
